import moment from "moment";

export class ChatContactDTO {
    public readonly phone?: string;
    public readonly avatar?: string;

    constructor(data: { phone?: string; avatar?: string }) {
        this.phone = data.phone;
        this.avatar = data.avatar;
    }

    public static fromRaw(raw: any): ChatContactDTO {
        return new ChatContactDTO({
            phone: raw.phone,
            avatar: raw.avatar,
        });
    }

    public toJSON(): {
        phone?: string;
        avatar?: string;
    } {
        return {
            phone: this.phone,
            avatar: this.avatar,
        };
    }
}

export class ChatItemDTO {
    public readonly info: any;
    public readonly name: string;
    public readonly chatId: string | null;
    public readonly countNotRead: number;
    public readonly lastMessage: string;
    public readonly lastMessageType: string;
    public readonly lastMessageContentUri: string;
    public readonly lastMessageDatetime: moment.Moment | null;

    constructor(data: {
        info: any;
        name: string;
        chatId: string | null;
        countNotRead: number;
        lastMessage: string;
        lastMessageType: string;
        lastMessageContentUri: string;
        lastMessageDatetime: moment.Moment | null;
    }) {
        this.info = data.info;
        this.name = data.name;
        this.chatId = data.chatId;
        this.countNotRead = data.countNotRead;
        this.lastMessage = data.lastMessage;
        this.lastMessageType = data.lastMessageType;
        this.lastMessageContentUri = data.lastMessageContentUri;
        this.lastMessageDatetime = data.lastMessageDatetime;
    }

    public static create(contact: any, phone: string | null, chatData: any): ChatItemDTO {
        return new ChatItemDTO({
            info: contact,
            name: `${contact.last_name ?? ""} ${contact.first_name ?? ""}`,
            chatId: phone,
            countNotRead: parseInt(chatData.count_not_read) || 0,
            lastMessage: chatData.text || "",
            lastMessageType: chatData.type || "text",
            lastMessageContentUri: chatData.content_uri || "",
            lastMessageDatetime: chatData.date_time ? moment(chatData.date_time) : null,
        });
    }

    public static fromRaw(raw: any): ChatItemDTO {
        return new ChatItemDTO({
            info: raw.info,
            name: raw.name || "",
            chatId: raw.chatId ?? null,
            countNotRead: raw.countNotRead || 0,
            lastMessage: raw.lastMessage || "",
            lastMessageType: raw.lastMessageType || "text",
            lastMessageContentUri: raw.lastMessageContentUri || "",
            lastMessageDatetime: raw.lastMessageDatetime ? moment(raw.lastMessageDatetime) : null,
        });
    }

    public toJSON(): {
        info: any;
        name: string;
        chatId: string | null;
        countNotRead: number;
        lastMessage: string;
        lastMessageType: string;
        lastMessageContentUri: string;
        lastMessageDatetime: string | null;
    } {
        return {
            info: this.info,
            name: this.name,
            chatId: this.chatId,
            countNotRead: this.countNotRead,
            lastMessage: this.lastMessage,
            lastMessageType: this.lastMessageType,
            lastMessageContentUri: this.lastMessageContentUri,
            lastMessageDatetime: this.lastMessageDatetime?.toISOString() || null,
        };
    }
}
